import { getIsDevToolsEnabled } from '@quickmd-llc/design-system';
import { isDeployedToProduction } from 'utils/isDeployedToProduction';

export const isDevToolsEnabled = () => getIsDevToolsEnabled(isDeployedToProduction);
